<section id="404" class="text-center has-error" style="margin-top: 10%">
  <h2>Requested ADEQ page is not available.</h2>
</section>
<div class="clear"></div>
<div class="actionbar" style="margin-top: 10%">
  <button type="button" class="btn btn-primary float-end" (click)="goBack()">
    GO BACK
    <span class="arrow right">
      <i class="fa fa-chevron-right"></i>
    </span>
  </button>
  <div class="clearfix"></div>
</div>
